import type { FC } from 'react';
import Container from 'react-bootstrap/Container';
import Header from '../../Header';
import { PackageProvider } from '../../Providers/Package';
import { PackagesManagement } from './PackagesManagement';

export const PackagesView: FC = () => {
  return (
    <PackageProvider>
      <Container fluid className="reservation-list-container">
        <Header title="Add-ons" />

        <PackagesManagement />
      </Container>
    </PackageProvider>
  );
};
